export default __webpack_public_path__ + "static/Undo-redo-4507492d40a6e054d984654e9f047a6b.png";